<template lang="pug">
  //- header#header(:class="{'header--compact': isCompact}" @click.prevent="isMenuShow = false")
  header#header
    .header__toggler(:class="{'header__toggler--opened': popup && popup.type === 'menu'}")
      a(href="#" @click.prevent="toggleMenu")
        span
        span
        span
    .header__logo
      a.text-hide(:href="logoLink")

</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mixins } from '@/utils/mixins';
export default {
  name: 'Header',
  mixins: [mixins],
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile', 'popup']),
    logoLink() {
      return process.env.VUE_APP_LOGO_LINK;
    },
  },
  methods: {
    ...mapActions(['openPopup', 'closePopup']),
    toggleMenu() {
      const { popup, openPopup, closePopup } = this;
      if (popup && popup.type === 'menu') {
        closePopup();
      } else {
        openPopup({ type: 'menu' })
      }
    },
  },
  created() {
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>

#header {

  display: flex;
  align-items: center;
  justify-content: space-between;

  position: fixed;
  top: -1px;
  left: 0;
  width: 100%;
  height: vw(107);
  padding: 0 vw(46);
  border-top: #d70d1a 1px solid;
  background: #d70d1a;
  z-index: 3;

  @include desktop {
    display: none;
  }

  .header__logo {
    width: vw(374);
    height: 100%;
    a {
      display: block;
      width: 100%;
      height: 100%;
      background: url('~@/assets/images/common/header-logo.png') no-repeat center center / contain;
    }
  }

  .header__toggler {
    width: vw(107);
    height: vw(107);

    a {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding: vw(29) 0;
    }

    span {
      width: vw(73);
      height: vw(5);
      border-radius: vw(5);
      background: #fff;
    }

    &--opened {

      a {
        justify-content: center;
      }

      span {
        &:nth-child(1) {transform: translateY(vw(2.5)) rotate(35deg);}
        &:nth-child(2) {display: none;}
        &:nth-child(3) {transform: translateY(vw(-2.5)) rotate(-35deg);}
      }

    }
  }

  &::after {
    content: '';
    width: vw(107);
  }

}

</style>
